import type { TChartSeries } from 'components/StackedChart/types'
import type { TooltipOptions } from 'highcharts'

export const environmentalLineChartSeriesMaker = (series: {
  aggregationInterval?: string | null
  color?: string
  name: string
  tooltip?: TooltipOptions
  values: {
    x: number | string
    y: number | null
    high?: number | null
    low?: number | null
    isDeviceReported?: boolean | null
  }[]
}): TChartSeries[] => {
  const { aggregationInterval, color, name, tooltip, values } = series
  const isDaily = aggregationInterval === 'DAILY'
  const lineSeriesId = `${aggregationInterval}-${name}`

  const lineSeries: TChartSeries = {
    color,
    name,
    tooltip,
    yAxis: 0,
    type: 'line',
    // @ts-expect-error
    data: values.map(({ x, low, high, y, isDeviceReported }) => ({
      x: +new Date(x),
      low: isDaily ? low : undefined,
      high: isDaily ? high : undefined,
      y,
      isDeviceReported,
    })),
    id: lineSeriesId,
    showInLegend: true,
    hideFromTooltip: false,
  }

  if (!isDaily) {
    return [lineSeries]
  }

  const arearangeSeries: TChartSeries = {
    color,
    name: `${name} hidden low/high`,
    tooltip,
    yAxis: 0,
    type: 'arearange',
    // @ts-expect-error
    data: values.map(({ x, low, high }) => ({ x: +new Date(x), low, high })),
    linkedTo: lineSeriesId,
    opacity: 0.3,
    zIndex: 0,
    id: `${lineSeriesId}-hidden-arearange`,
    hideFromTooltip: true,
  }

  return [lineSeries, arearangeSeries] as TChartSeries[]
}
